import {
  createDefaultProfile,
  normalizeProfile,
  type PlayerProfile,
} from "../core/profile";

const PROFILE_KEY = "egg-arena:profile:v1";

export function loadProfile(): PlayerProfile {
  try {
    const encoded = window.localStorage.getItem(PROFILE_KEY);
    return encoded ? normalizeProfile(JSON.parse(encoded) as unknown) : createDefaultProfile();
  } catch {
    return createDefaultProfile();
  }
}

export function saveProfile(profile: PlayerProfile): void {
  try {
    window.localStorage.setItem(PROFILE_KEY, JSON.stringify(normalizeProfile(profile)));
  } catch {
    // Profile persistence is optional when browser storage is unavailable.
  }
}
